import utility from "../lib/utility.js";
import { Report_promotion_service } from "../services/Report_promotion_service";
import { Typegroup_service } from "../services/Typegroup.service";
import { Operator_service } from "../services/Operator_service";
import { reportG2 } from "./../services/reportG2.service";
import { Loading } from "element-ui"
const moment = require("moment");
const state = {
    month_th : ["มกราคม","กุมภาพันธ์","มีนาคม","เมษายน","พฤษภาคม","มิถุนายน ","กรกฎาคม","สิงหาคม","กันยายน","ตุลาคม","พฤศจิกายน","ธันวาคม"],
    short_month : ['ม.ค.','ก.พ.','มี.ค.','เม.ย.','พ.ค.','มิ.ย.','ก.ค.','ส.ค.','ก.ย.','ต.ค.','พ.ย.','ธ.ค.'],
    fq_th : {
        900 : ' 900 MHz ',
        1800 : ' 1800 MHz ',
        2100 : ' 2.1 GHz ',
        other : 'อื่น ๆ '
    },
    datasets: [],
    options: {},
    regulates : [],
    groupList : [],
    providerList : [],
    quarterdata : [],
    table_data : {},
    display_status : false,
    display_text : '',
    display_regulate : [],
    reducer: []
}
const actions = {
    async serviceRegulate({commit},data){
        let result = await Report_promotion_service.getServiceRegulate()
        if(result.status === 200){
            commit('SERVICE_REGULATE',result.data)
        }else{
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })        
        }
    },
    async getGroupList({commit}){
        let result = await Typegroup_service.getGroupList({provider_type : 'mobile'})
        if(result.status === 200){
            commit('GROUP_LIST', result.data)
        }else{
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })        
        }
    },
    async getOperatorList({commit}){
        let result = await Operator_service.getProviderList('mobile')
        if(result.status === 200){
            commit('PROVIDER_LIST', result.data)
        }else{
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })        
        }
    },
    async quarterReport({state,commit},formdata){
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
        formdata.type_data = {
            quarter : formdata.quarter,
            quarter_year : formdata.year
        }
        formdata.provider_list = typeof(formdata.provider_list) == 'number' ? [formdata.provider_list] : formdata.provider_list
        let result = await reportG2.getAllReportData(formdata)
        if(!result.data) {
            setTimeout(function(){ loadingInstance.close() }, 250);
            return commit('DISPLAY_STATUS',false);
        }
        let qrydata = Object.values(result.data[0])[0]
        let proportion = await reportG2.getProportionMobileRate()
            proportion = proportion.data[0] || null
            proportion['main'] = proportion.proportion_main_promotion ? proportion.proportion_main_promotion*0.01 : 1
            proportion['on-top'] = proportion.proportion_ontop_promotion ? proportion.proportion_ontop_promotion*0.01 : 1
        let regulator = moment(formdata.year).year() <= 2019 
                    ? state.regulates.filter(item => item['signal_'+formdata.frequency] == 1)[0]
                    : state.regulates.filter(item => moment(item.start_date).year() > 2019)[0]
        let daterange = result.data.pop()
            formdata.daterange = daterange
        let table_data = {}
            table_data.text_title = 'ตารางอัตราค่าบริการเฉลี่ยของทุกรายการส่งเสริมการขายที่เป็นไปตามประกาศสำนักงาน กสทช.'
                            +' ในไตรมาสที่ '+formdata.quarter+' ปี พ.ศ. '+moment(formdata.year).add(543,'Y').format('YYYY')
                            +' และเปรียบเทียบกับ'+regulator.service_name
            table_data.provider_name = formdata.compare_type == 'group' ? formdata.list[0].group_name_th : formdata.list[0].brand_name
            table_data.quarter = 'ไตรมาสที่ '+formdata.quarter+' ปี พ.ศ. '+moment(formdata.year).add(543,'Y').format('YYYY')
            table_data.short_month = []
            table_data.amount = {}
        let avg = { Voice: {}, SMS: {}, MMS: {}, Internet: {} }
        let provider_list = formdata.compare_type == 'group' ? JSON.parse(formdata.list[0].group_company_list) : formdata.provider_list
        for(let date = daterange[0],end = daterange[1]; date <= end ; date = moment(date).add(1,'M').format('YYYY-MM-DD')){
            let date_key = moment(date).format('MM-YYYY')
            for(let service in avg){
                avg[service][date_key] = {}
                for(let id of provider_list){
                    avg[service][date_key][id] = {'main' : [], 'on-top': []}
                }
            }
            table_data.amount[date_key] = 0
            table_data.short_month.push(state.short_month[moment(date,'YYYY-MM-DD').month()])
        } 
        for(let item of qrydata){
            let date_key = moment(item.monthly_regulate).format('MM-YYYY')
            if(item.price_avg){
                avg[item.service_type][date_key][item.provider_id]['main'] = [item.price_avg]
                avg[item.service_type][date_key][item.provider_id]['on-tp['] = []
                table_data.amount[date_key] = item.total
            }else{
                avg['Voice'][date_key][item.provider_id][item.promotion_type].push(item.Voice)
                avg['SMS'][date_key][item.provider_id][item.promotion_type].push(item.SMS)
                avg['MMS'][date_key][item.provider_id][item.promotion_type].push(item.MMS)
                avg['Internet'][date_key][item.provider_id][item.promotion_type].push(item.Internet)
                table_data.amount[date_key] += item.total
            }
        }
        for(let service in avg){
            for(let date in avg[service]){
                for(let provider in avg[service][date]){
                    if(avg[service][date][provider]['on-top'][0]){
                        avg[service][date][provider] = avg[service][date][provider]['main'][0] 
                            ? eval(avg[service][date][provider]['main'].join('+'))*proportion['main'] + eval(avg[service][date][provider]['on-top'].join('+'))*proportion['on-top'] 
                            : eval(avg[service][date][provider]['on-top'].join('+'))*proportion['on-top']
                    }else{
                        avg[service][date][provider] = avg[service][date][provider]['main'][0] ? avg[service][date][provider]['main'][0] : 0
                    }
                }
                avg[service][date] = Object.values(avg[service][date]).filter(n => n > 0)
                avg[service][date] = eval(avg[service][date].join('+')) / avg[service][date].length
            }
        }
        table_data.status = { Voice: '', SMS: '', MMS: '', Internet: '' }
        table_data.regulate = {
            name : regulator.service_name,
            Voice : parseFloat((regulator.voice_service_rate).toFixed(2)),
            SMS : parseFloat((regulator.sms_service_rate).toFixed(2)),
            MMS : parseFloat((regulator.mms_service_rate).toFixed(2)),
            Internet : parseFloat((regulator.internet_service_rate).toFixed(2)),
        }
        let addon = state.regulates
            addon = addon.filter(item => ((item.id !== regulator.id) && formdata.rate_addon.includes(item.id)))
            state.reducer = (formdata.frequency == 2100 && moment(formdata.year).year() < 2020)
                ? [{
                    service_name : 'อัตราเฉลี่ยต้องลดลง',
                    voice_service_rate : parseFloat((regulator.voice_service_rate*0.85).toFixed(2)),
                    sms_service_rate : parseFloat((regulator.sms_service_rate*0.85).toFixed(2)),
                    mms_service_rate : parseFloat((regulator.mms_service_rate*0.85).toFixed(2)),
                    internet_service_rate : parseFloat((regulator.internet_service_rate*0.85).toFixed(2)),
                }]
                : []
        commit('SET_REGULATE_ADDON',addon)

        table_data.percent = {}
        table_data.checked = {}
        let compare
        for(let sv in avg){ 
            compare = Object.values(avg[sv])
            table_data.status[sv] = compare[0] ? compare[0] > (compare[2] ? compare[2] : compare[1]) ? 'ลดลง' : compare[0] < (compare[2] ? compare[2] : compare[1]) ? 'เพิ่มขึ้น' : 'คงที่' : 'ไม่มีบริการ'
            table_data.percent[sv] = {}
            for(let month in avg[sv]){
                table_data.percent[sv][month] = avg[sv][month] > 0 ? parseFloat((avg[sv][month]/table_data.regulate[sv]*100-100).toFixed(2)) : ''
                // avg[sv][month] = parseFloat(avg[sv][month].toFixed(2))
                table_data.checked[month] = avg[sv][month] > 0 ? table_data.checked[month] ==  '✖' ? '✖' : (avg[sv][month] > table_data.regulate[sv] ? '✖' : '✔') : ''
            }
        }
        table_data.avg = avg
        table_data.amount = Object.values(table_data.amount)
        commit('SET_TABLE_DATA',table_data)
        commit('DISPLAY_STATUS', true)
        setTimeout(function(){ loadingInstance.close() }, 250);
    }
};

const mutations = {
    SERVICE_REGULATE(state,data){
        state.regulates = data
    },
    GROUP_LIST(state,data){
        state.groupList = data
    },
    PROVIDER_LIST(state,data){
        state.providerList = data
    },
    SET_TABLE_DATA(state,data){
        state.table_data = data
    },
    DISPLAY_STATUS(state, status){
        state.display_status = status
        state.display_text = !status ? 'ไม่พบข้อมูลการค้นหา' : ''
    },
    SET_REGULATE_ADDON(state, items){
        state.display_regulate = items
    }
};

export const Report_G6 = {
    namespaced: true,
    state,
    actions,
    mutations
};